import { ChangeDetectionStrategy, Component, forwardRef, Input, OnDestroy, OnInit } from '@angular/core';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR } from '@angular/forms';

import { BaseCtrlValueAccessorFormArrayComponent, FormManagerService } from '@sim/form';
import { ClassName } from '@sim/role';

import { LA, LAMeta } from '@atmi/core/models';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      multi: true,
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => LaFormComponent),
    },
    {
      multi: true,
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => LaFormComponent),
    },
  ],
  selector: 'app-la-form',
  styleUrls: ['./la-form.component.scss'],
  templateUrl: './la-form.component.html',
})
export class LaFormComponent extends BaseCtrlValueAccessorFormArrayComponent<LA> implements OnDestroy, OnInit {

  @Input() classNames: ClassName[] = [];

  constructor(
    private readonly formManager: FormManagerService,
  ) {
    super();
  }

  ngOnInit() {
    super.ngOnInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  addHandler() {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage LA without a control');
    }

    const control = this.formManager.makeForm(LAMeta, {} as LA);
    this.form.push(control);
  }

  removeHandler(index: number) {
    if (!this.form || !this.form.controls) {
      throw new Error('Cannot manage LA without a control');
    }

    this.form.removeAt(index);
  }
}
